module.exports = __webpack_public_path__ + "img/ring_y_l_0_0@3x.4e12be3a.png";